import domready from "domready";
import "../elements/navigation--viewport";
domready(function () {
  var maxContentWidth = 1280;
  var contentBorder = calculateContentBorder();
  var thirdLevels = document.querySelectorAll(".navigation--third-level");
  var mql = window.matchMedia("(max-width: 64rem)");
  var isMobile = mql.matches;
  var navCheckboxState = document.getElementById("navigation-state");

  /**
   * Initialize Menu settings
   */
  setThirdLevelHeight();
  setThirdLevelWidth();
  checkMegaMenuOversize();

  /**
   * Listen to breakpoint cross
   * set isMobile variable
   * set correct menu third level element heights
   * change from mobile to desktop -> close mobile menu
   */
  mql.addListener(function () {
    isMobile = mql.matches;
    setThirdLevelHeight();
    if (!isMobile && navCheckboxState.checked) {
      navCheckboxState.checked = false;
    }
    if (!isMobile) {
      setThirdLevelWidth();
    }
  });

  /**
   * Close language-menu if mobile navigation is opened
   */
  const toggleMenu = document.querySelector(".top-bar__toggle--menu");
  if (toggleMenu) {
    toggleMenu.addEventListener("click", function() {
        var languageMenuState = document.querySelector("#language-state");
        if (isMobile && languageMenuState.checked) {
          languageMenuState.checked = false;
        }
      });
  }

  /**
   * Set menu third level element height
   * if mobile, set initial height to third level list elements
   * if desktop, set height of highest third level list element to all other elements
   * (in desktop all third level elements get the same 'max height'
   */
  function setThirdLevelHeight() {
    if (isMobile) {
      Array.prototype.slice.call(thirdLevels).forEach(function (thirdLevel) {
        thirdLevel.style.height = "initial";
        thirdLevel.style.color = "red";
      });
    } else if (!isMobile) {
      var thirdLevelMaxHeight = 0;
      Array.prototype.slice.call(thirdLevels).forEach(function (thirdLevel) {
        var thirdLevelHeight = thirdLevel.offsetHeight;
        if (thirdLevelHeight > thirdLevelMaxHeight) {
          thirdLevelMaxHeight = thirdLevelHeight;
        }
      });
      Array.prototype.slice.call(thirdLevels).forEach(function (thirdLevel) {
        thirdLevel.style.height = thirdLevelMaxHeight + "px";
      });
    }
  }

  /**
   * Calculate width of content borders
   * ( page width - maxContentWidth)
   * @returns {number}
   */
  function calculateContentBorder() {
    return (window.innerWidth - maxContentWidth) / 2;
  }

  /**
   * Set width of menu's third level elements
   */
  function setThirdLevelWidth() {
    var thirdLevels = document.querySelectorAll(".navigation--third-level");

    let widestThirdLevelWidth = 0;
    thirdLevels.forEach((thirdLevel) => {
      const thirdLevelWidth = thirdLevel.offsetWidth;
      if (thirdLevelWidth > widestThirdLevelWidth) {
        widestThirdLevelWidth = thirdLevelWidth;
      }
    });

    // Add correct width to 2nd and 3rd levels
    thirdLevels.forEach((thirdLevel) => {
      thirdLevel.addEventListener("transitionend", function () {
        thirdLevel.style.width = `${widestThirdLevelWidth}px`;
        if (widestThirdLevelWidth > thirdLevel.parentElement.offsetWidth) {
          return thirdLevel.parentElement.style.width = `${widestThirdLevelWidth}px`;
        }
      });
      thirdLevel.style.width = `${widestThirdLevelWidth}px`;
      if (widestThirdLevelWidth > thirdLevel.parentElement.offsetWidth) {
        return thirdLevel.parentElement.style.width = `${widestThirdLevelWidth}px`;
      }
    });
  }

  /**
   * Check if Menu is overflowing the window and window is wider as maxContent
   *    if so, translate with border
   *    if window smaller than maxContent, translate to right = 0
   */
  function checkMegaMenuOversize() {
    var secondLevelLists = document.querySelectorAll(".navigation--second-level");
    Array.prototype.forEach.call(secondLevelLists, function (secondLevelList) {
      secondLevelList.style.transform = "translateX(0)";
      var positionX = secondLevelList.getBoundingClientRect().x;
      var secondLevelListWidth = secondLevelList.getBoundingClientRect().width;
      var isOverlapping = checkIfOverlap(positionX, secondLevelListWidth);
      var listOverlapRight = positionX + secondLevelListWidth - window.innerWidth;
      if (!isMobile && isOverlapping && window.innerWidth > maxContentWidth) {
        var rightBorder = calculateContentBorder();
        translateList(secondLevelList, rightBorder + listOverlapRight);
      } else if (!isMobile && isOverlapping && !(window.innerWidth > maxContentWidth)) {
        translateList(secondLevelList, listOverlapRight);
      }
    });
  }

  /**
   * Translate List Item a set amount of pixels
   * @param listEL
   * @param amount
   * @returns {string}
   */
  function translateList(listEL, amount) {
    return listEL.style.transform = "translateX(-" + amount + "px)";
  }

  /**
   * Check if menu is overflowing the window
   * @param positionX
   * @param secondLevelListWidth
   * @returns {boolean}
   */
  function checkIfOverlap(positionX, secondLevelListWidth) {
    return positionX + secondLevelListWidth > window.innerWidth;
  }

  /**
   * window resize event listener
   */
  window.addEventListener("resize", function () {
    checkMegaMenuOversize();
  });

  const wrapNavigation =  document.querySelector(".wrap--navigation");
  if (wrapNavigation) {
    wrapNavigation.addEventListener("transitionend", function (event) {
      var eventTarget = event.target;
      if (eventTarget.classList.contains("wrap--navigation")) {
        checkMegaMenuOversize();
      }
    });
  }
});
